/* tslint:disable */
/* eslint-disable */
/* @relayHash 4019889587f8ad12b8d461db1792b123 */

import { ConcreteRequest } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type Currency = "AUD" | "CAD" | "CHF" | "EUR" | "GBP" | "JPY" | "MXN" | "USD" | "%future added value";
export type PdpRespLayoutRefetchQueryVariables = {
    isClient: boolean;
    itemId: string;
    itemIds: Array<string | null>;
    userId?: string | null;
    userIds?: Array<string | null> | null;
    fetchUser: boolean;
    relationshipUserIds: Array<string | null>;
    followSearchPages?: Array<string | null> | null;
    fetchFollowSearch: boolean;
    isTrade: boolean;
    isVip: boolean;
    isMultiSku: boolean;
    fetchPdp: boolean;
    forcedCurrency?: Currency | null;
    userZipCode?: string | null;
    userCountryCode?: string | null;
    fetchRegionalInfo?: boolean | null;
    localRecentHistoryItemIds?: Array<string | null> | null;
    fetchUserRecentHistoryItem?: boolean | null;
};
export type PdpRespLayoutRefetchQueryResponse = {
    readonly viewer: {
        readonly " $fragmentRefs": FragmentRefs<"PdpRespLayout_viewer">;
    };
};
export type PdpRespLayoutRefetchQuery = {
    readonly response: PdpRespLayoutRefetchQueryResponse;
    readonly variables: PdpRespLayoutRefetchQueryVariables;
};



const node: ConcreteRequest = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "isClient",
    "type": "Boolean!",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "itemId",
    "type": "String!",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "itemIds",
    "type": "[String]!",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "userId",
    "type": "String",
    "defaultValue": ""
  },
  {
    "kind": "LocalArgument",
    "name": "userIds",
    "type": "[String]",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "fetchUser",
    "type": "Boolean!",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "relationshipUserIds",
    "type": "[String]!",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "followSearchPages",
    "type": "[String]",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "fetchFollowSearch",
    "type": "Boolean!",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "isTrade",
    "type": "Boolean!",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "isVip",
    "type": "Boolean!",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "isMultiSku",
    "type": "Boolean!",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "fetchPdp",
    "type": "Boolean!",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "forcedCurrency",
    "type": "Currency",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "userZipCode",
    "type": "String",
    "defaultValue": "0"
  },
  {
    "kind": "LocalArgument",
    "name": "userCountryCode",
    "type": "String",
    "defaultValue": ""
  },
  {
    "kind": "LocalArgument",
    "name": "fetchRegionalInfo",
    "type": "Boolean",
    "defaultValue": false
  },
  {
    "kind": "LocalArgument",
    "name": "localRecentHistoryItemIds",
    "type": "[String]",
    "defaultValue": ([]/*: any*/)
  },
  {
    "kind": "LocalArgument",
    "name": "fetchUserRecentHistoryItem",
    "type": "Boolean",
    "defaultValue": false
  }
],
v1 = {
  "kind": "Variable",
  "name": "buyerId",
  "variableName": "userId"
},
v2 = {
  "kind": "Variable",
  "name": "itemId",
  "variableName": "itemId"
},
v3 = [
  (v1/*: any*/),
  (v2/*: any*/)
],
v4 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "status",
  "args": null,
  "storageKey": null
},
v5 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "currency",
  "args": null,
  "storageKey": null
},
v6 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "amount",
  "args": null,
  "storageKey": null
},
v7 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "convertedAmountList",
  "storageKey": null,
  "args": null,
  "concreteType": "ConvertedAmountList",
  "plural": true,
  "selections": [
    (v5/*: any*/),
    (v6/*: any*/)
  ]
},
v8 = [
  (v7/*: any*/)
],
v9 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
},
v10 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "code",
  "args": null,
  "storageKey": null
},
v11 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "regionName",
  "args": null,
  "storageKey": null
},
v12 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "shippingAddress",
  "storageKey": null,
  "args": null,
  "concreteType": "Address",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "displayCityStateCountry",
      "args": null,
      "storageKey": null
    },
    (v9/*: any*/)
  ]
},
v13 = [
  {
    "kind": "Literal",
    "name": "formatType",
    "value": "INTERNATIONAL"
  }
],
v14 = {
  "kind": "Variable",
  "name": "countryCode",
  "variableName": "userCountryCode"
},
v15 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "__typename",
  "args": null,
  "storageKey": null
},
v16 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "isMultiSku",
  "args": null,
  "storageKey": null
},
v17 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "name",
  "args": null,
  "storageKey": null
},
v18 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "skuId",
  "args": null,
  "storageKey": null
},
v19 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "serviceId",
  "args": null,
  "storageKey": null
},
v20 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "firstPhotoWebPath",
  "args": [
    {
      "kind": "Literal",
      "name": "size",
      "value": "small"
    }
  ],
  "storageKey": "firstPhotoWebPath(size:\"small\")"
},
v21 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "quantity",
  "args": null,
  "storageKey": null
},
v22 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "hasUnlimitedQuantity",
  "args": null,
  "storageKey": null
},
v23 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "label",
  "args": null,
  "storageKey": null
},
v24 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "value",
  "args": null,
  "storageKey": null
},
v25 = [
  {
    "kind": "Literal",
    "name": "pageType",
    "value": "PDP"
  }
],
v26 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "percentageOff",
  "storageKey": null,
  "args": null,
  "concreteType": "PercentageOff",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "salePrice",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "netPrice",
      "args": null,
      "storageKey": null
    }
  ]
},
v27 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "saleOriginPrice",
  "storageKey": null,
  "args": null,
  "concreteType": "FinancialAmount",
  "plural": false,
  "selections": (v8/*: any*/)
},
v28 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "retailPrice",
  "storageKey": null,
  "args": null,
  "concreteType": "FinancialAmount",
  "plural": false,
  "selections": (v8/*: any*/)
},
v29 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "salePrice",
  "storageKey": null,
  "args": null,
  "concreteType": "FinancialAmount",
  "plural": false,
  "selections": (v8/*: any*/)
},
v30 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "netPrice",
  "storageKey": null,
  "args": null,
  "concreteType": "FinancialAmount",
  "plural": false,
  "selections": (v8/*: any*/)
},
v31 = [
  (v1/*: any*/),
  {
    "kind": "Literal",
    "name": "page",
    "value": "pdp"
  }
],
v32 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "quantityDisplay",
  "args": null,
  "storageKey": null
},
v33 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "showSold",
  "args": null,
  "storageKey": null
},
v34 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "showUnavailable",
  "args": null,
  "storageKey": null
},
v35 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "showPUR",
  "args": null,
  "storageKey": null
},
v36 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "showNet",
  "args": null,
  "storageKey": null
},
v37 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "showSale",
  "args": null,
  "storageKey": null
},
v38 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "showRetail",
  "args": null,
  "storageKey": null
},
v39 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "showOriginal",
  "args": null,
  "storageKey": null
},
v40 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "showOnHold",
  "args": null,
  "storageKey": null
},
v41 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "showOnHoldCustom",
  "args": null,
  "storageKey": null
},
v42 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "showListPriceLabel",
  "args": null,
  "storageKey": null
},
v43 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "title",
  "args": null,
  "storageKey": null
},
v44 = [
  {
    "kind": "Literal",
    "name": "size",
    "value": "thumb"
  }
],
v45 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "key",
  "args": null,
  "storageKey": null
},
v46 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "path",
  "args": null,
  "storageKey": null
},
v47 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "displayName",
  "args": null,
  "storageKey": null
},
v48 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "largePath",
  "args": null,
  "storageKey": null
},
v49 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "sortOrder",
  "args": null,
  "storageKey": null
},
v50 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "pdpURL",
  "args": null,
  "storageKey": null
},
v51 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "vertical",
  "args": null,
  "storageKey": null
},
v52 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "browseUrl",
  "args": null,
  "storageKey": null
},
v53 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "creationDate",
  "args": null,
  "storageKey": null
},
v54 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "isArt",
  "args": null,
  "storageKey": null
},
v55 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "contemporaryTrackingString",
  "args": null,
  "storageKey": null
},
v56 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "convertedAmounts",
  "storageKey": null,
  "args": null,
  "concreteType": "ConvertedAmounts",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "USD",
      "args": null,
      "storageKey": null
    }
  ]
},
v57 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "type",
  "args": null,
  "storageKey": null
},
v58 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "categoryCode",
  "args": null,
  "storageKey": null
},
v59 = [
  (v1/*: any*/)
],
v60 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "urlLabel",
  "args": null,
  "storageKey": null
},
v61 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "text",
  "args": null,
  "storageKey": null
},
v62 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "accept",
  "args": null,
  "storageKey": null
},
v63 = [
  (v46/*: any*/),
  {
    "kind": "ScalarField",
    "alias": null,
    "name": "isLinkable",
    "args": null,
    "storageKey": null
  }
],
v64 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "shipmentQuotes",
  "storageKey": null,
  "args": null,
  "concreteType": "ShipmentQuote",
  "plural": true,
  "selections": [
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "totalAmount",
      "storageKey": null,
      "args": null,
      "concreteType": "FinancialAmount",
      "plural": false,
      "selections": [
        (v6/*: any*/)
      ]
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "serviceMethod",
      "storageKey": null,
      "args": null,
      "concreteType": "ShipmentServiceMethod",
      "plural": false,
      "selections": [
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "region",
          "storageKey": null,
          "args": null,
          "concreteType": "Region",
          "plural": false,
          "selections": [
            (v11/*: any*/),
            (v9/*: any*/)
          ]
        },
        (v9/*: any*/)
      ]
    },
    (v9/*: any*/)
  ]
},
v65 = {
  "kind": "Variable",
  "name": "userId",
  "variableName": "userId"
},
v66 = [
  (v65/*: any*/)
],
v67 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "description",
  "args": null,
  "storageKey": null
},
v68 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "isCustomizable",
  "args": null,
  "storageKey": null
},
v69 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "categoryPath",
  "args": null,
  "storageKey": null
},
v70 = [
  (v23/*: any*/),
  (v9/*: any*/)
],
v71 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "showHoldRequest",
  "args": null,
  "storageKey": null
},
v72 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "showPurchase",
  "args": null,
  "storageKey": null
},
v73 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "showMakeOffer",
  "args": null,
  "storageKey": null
},
v74 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "showRequestPrice",
  "args": null,
  "storageKey": null
},
v75 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "showRequestSourcing",
  "args": null,
  "storageKey": null
},
v76 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "showFollowCategory",
  "args": null,
  "storageKey": null
},
v77 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "showAcceptOffer",
  "args": null,
  "storageKey": null
},
v78 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "localizedPdpUrl",
  "args": null,
  "storageKey": null
},
v79 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "webPath",
  "args": null,
  "storageKey": null
},
v80 = [
  (v17/*: any*/)
],
v81 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "masterOrZoomPath",
  "args": null,
  "storageKey": null
},
v82 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "alt",
  "args": null,
  "storageKey": null
},
v83 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "firstName",
  "args": null,
  "storageKey": null
},
v84 = [
  (v19/*: any*/),
  (v9/*: any*/)
],
v85 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "seller",
  "storageKey": null,
  "args": null,
  "concreteType": "Seller",
  "plural": false,
  "selections": (v84/*: any*/)
},
v86 = [
  (v17/*: any*/),
  (v9/*: any*/)
],
v87 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "isJewelry",
  "args": null,
  "storageKey": null
},
v88 = {
  "kind": "Literal",
  "name": "addLabel",
  "value": false
},
v89 = [
  {
    "kind": "ScalarField",
    "alias": null,
    "name": "unit",
    "args": null,
    "storageKey": null
  },
  (v24/*: any*/)
],
v90 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "detailKey",
  "args": null,
  "storageKey": null
},
v91 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "ecommerceTrackingParams",
  "args": null,
  "storageKey": null
},
v92 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "isFurniture",
  "args": null,
  "storageKey": null
},
v93 = {
  "kind": "Variable",
  "name": "isTrade",
  "variableName": "isTrade"
},
v94 = {
  "kind": "Literal",
  "name": "page",
  "value": "searchAndBrowse"
},
v95 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "convertedAmountList",
  "storageKey": null,
  "args": null,
  "concreteType": "ConvertedAmountList",
  "plural": true,
  "selections": [
    (v6/*: any*/),
    (v5/*: any*/)
  ]
},
v96 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "displayPrice",
  "storageKey": null,
  "args": [
    (v93/*: any*/),
    (v94/*: any*/)
  ],
  "concreteType": "ItemDisplayPriceType",
  "plural": true,
  "selections": [
    (v95/*: any*/),
    (v32/*: any*/),
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "percentageOff",
      "args": null,
      "storageKey": null
    },
    (v57/*: any*/),
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "showPriceLabel",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "showPriceVariability",
      "args": null,
      "storageKey": null
    }
  ]
},
v97 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "classification",
  "storageKey": null,
  "args": null,
  "concreteType": "ItemClassification",
  "plural": false,
  "selections": [
    (v53/*: any*/)
  ]
},
v98 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "creators",
  "storageKey": null,
  "args": null,
  "concreteType": "ItemCreator",
  "plural": true,
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "attribution",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "creator",
      "storageKey": null,
      "args": null,
      "concreteType": "Creator",
      "plural": false,
      "selections": [
        (v47/*: any*/),
        (v9/*: any*/)
      ]
    },
    (v9/*: any*/)
  ]
},
v99 = [
  {
    "kind": "Literal",
    "name": "limit",
    "value": 1
  }
],
v100 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "placeholder",
  "args": null,
  "storageKey": null
},
v101 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "versions",
  "storageKey": null,
  "args": null,
  "concreteType": "ItemPhotoVersion",
  "plural": true,
  "selections": [
    (v79/*: any*/)
  ]
},
v102 = {
  "kind": "LinkedField",
  "alias": "productPhotos",
  "name": "photos",
  "storageKey": "photos(limit:1)",
  "args": (v99/*: any*/),
  "concreteType": "ItemPhoto",
  "plural": true,
  "selections": [
    (v100/*: any*/),
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "smallPath",
      "args": null,
      "storageKey": null
    },
    (v81/*: any*/),
    (v101/*: any*/),
    (v9/*: any*/)
  ]
},
v103 = [
  {
    "kind": "Literal",
    "name": "formatType",
    "value": "MOBILE"
  }
],
v104 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "quickViewDisplay",
  "storageKey": null,
  "args": null,
  "concreteType": "QuickViewDisplayType",
  "plural": false,
  "selections": [
    (v43/*: any*/),
    {
      "kind": "ScalarField",
      "alias": "mobileTitle",
      "name": "title",
      "args": (v103/*: any*/),
      "storageKey": "title(formatType:\"MOBILE\")"
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "paragraphs",
      "storageKey": null,
      "args": null,
      "concreteType": "QuickViewParagraph",
      "plural": true,
      "selections": [
        (v45/*: any*/),
        (v61/*: any*/),
        {
          "kind": "ScalarField",
          "alias": "mobileText",
          "name": "text",
          "args": (v103/*: any*/),
          "storageKey": "text(formatType:\"MOBILE\")"
        }
      ]
    }
  ]
},
v105 = {
  "kind": "Literal",
  "name": "first",
  "value": 12
},
v106 = [
  (v105/*: any*/)
],
v107 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "isPrivateOffer",
  "args": null,
  "storageKey": null
},
v108 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "canUseOfferForCheckout",
  "args": null,
  "storageKey": null
},
v109 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "amountPerItem",
  "storageKey": null,
  "args": null,
  "concreteType": "FinancialAmount",
  "plural": false,
  "selections": (v8/*: any*/)
},
v110 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "amount",
    "storageKey": null,
    "args": null,
    "concreteType": "FinancialAmount",
    "plural": false,
    "selections": (v8/*: any*/)
  }
],
v111 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "offers",
  "storageKey": null,
  "args": null,
  "concreteType": "Offer",
  "plural": true,
  "selections": [
    (v108/*: any*/),
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "expirationDate",
      "args": null,
      "storageKey": null
    },
    (v109/*: any*/),
    (v9/*: any*/)
  ]
},
v112 = [
  (v6/*: any*/),
  (v5/*: any*/),
  (v7/*: any*/)
],
v113 = [
  {
    "kind": "Variable",
    "name": "buyerId",
    "variableName": "userIds"
  },
  {
    "kind": "Variable",
    "name": "itemId",
    "variableName": "itemIds"
  }
],
v114 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "email",
  "args": null,
  "storageKey": null
},
v115 = [
  (v10/*: any*/),
  (v9/*: any*/)
],
v116 = {
  "kind": "Literal",
  "name": "relationshipType",
  "value": "VIP"
},
v117 = [
  (v47/*: any*/)
],
v118 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "daysRelativeToExpiration",
  "args": [
    {
      "kind": "Literal",
      "name": "truncate",
      "value": false
    }
  ],
  "storageKey": "daysRelativeToExpiration(truncate:false)"
},
v119 = [
  {
    "kind": "Variable",
    "name": "excludeItemPks",
    "variableName": "localRecentHistoryItemIds"
  },
  (v105/*: any*/)
],
v120 = {
  "kind": "ScalarField",
  "alias": "isPinterestShareEnabled",
  "name": "isEnabledByLocale",
  "args": [
    {
      "kind": "Literal",
      "name": "featureName",
      "value": "PINTEREST_SHARE"
    }
  ],
  "storageKey": "isEnabledByLocale(featureName:\"PINTEREST_SHARE\")"
};
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "PdpRespLayoutRefetchQuery",
    "type": "RootQueryType",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "Viewer",
        "plural": false,
        "selections": [
          {
            "kind": "FragmentSpread",
            "name": "PdpRespLayout_viewer",
            "args": null
          }
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "PdpRespLayoutRefetchQuery",
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "Viewer",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "relevantShipping",
            "storageKey": null,
            "args": (v3/*: any*/),
            "concreteType": "RelevantShippingInfo",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "quoteRequestStatus",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "shipmentQuote",
                "storageKey": null,
                "args": null,
                "concreteType": "ShipmentQuote",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "isCustom",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "isNew",
                    "args": null,
                    "storageKey": null
                  },
                  (v4/*: any*/),
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "buyerTotalAmount",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "FinancialAmount",
                    "plural": false,
                    "selections": (v8/*: any*/)
                  },
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "serviceMethod",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "ShipmentServiceMethod",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "isWhiteGlove",
                        "args": null,
                        "storageKey": null
                      },
                      (v9/*: any*/),
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "serviceMethodType",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "region",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "Region",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "apiType",
                            "args": null,
                            "storageKey": null
                          },
                          (v10/*: any*/),
                          (v11/*: any*/),
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "regionType",
                            "args": null,
                            "storageKey": null
                          },
                          (v9/*: any*/)
                        ]
                      }
                    ]
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "handlingTimeDisplay",
                    "args": [
                      {
                        "kind": "Literal",
                        "name": "displayShort",
                        "value": true
                      }
                    ],
                    "storageKey": "handlingTimeDisplay(displayShort:true)"
                  },
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "totalAmount",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "FinancialAmount",
                    "plural": false,
                    "selections": [
                      (v5/*: any*/),
                      (v6/*: any*/),
                      (v7/*: any*/)
                    ]
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "buyerServiceMethodDisplay",
                    "args": null,
                    "storageKey": null
                  },
                  (v9/*: any*/)
                ]
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "shipment",
                "storageKey": null,
                "args": null,
                "concreteType": "Shipment",
                "plural": false,
                "selections": [
                  (v12/*: any*/),
                  (v9/*: any*/)
                ]
              }
            ]
          },
          {
            "kind": "ScalarField",
            "alias": "isEnabled",
            "name": "isEnabledByLocale",
            "args": [
              {
                "kind": "Literal",
                "name": "featureName",
                "value": "PDP_SUPPORT_NUMBER_BLURB"
              }
            ],
            "storageKey": "isEnabledByLocale(featureName:\"PDP_SUPPORT_NUMBER_BLURB\")"
          },
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "contactInfo",
            "storageKey": null,
            "args": null,
            "concreteType": "ContactInfo",
            "plural": false,
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "phoneNumbers",
                "storageKey": null,
                "args": null,
                "concreteType": "support",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "support",
                    "args": (v13/*: any*/),
                    "storageKey": "support(formatType:\"INTERNATIONAL\")"
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "tradeSupport",
                    "args": (v13/*: any*/),
                    "storageKey": "tradeSupport(formatType:\"INTERNATIONAL\")"
                  }
                ]
              }
            ]
          },
          {
            "kind": "ScalarField",
            "alias": "isItemInvoiceEnabled",
            "name": "isEnabledByLocale",
            "args": [
              {
                "kind": "Literal",
                "name": "featureName",
                "value": "INVOICE"
              }
            ],
            "storageKey": "isEnabledByLocale(featureName:\"INVOICE\")"
          },
          {
            "kind": "ScalarField",
            "alias": "isSeoQuicklookEnabled",
            "name": "isEnabledByLocale",
            "args": [
              {
                "kind": "Literal",
                "name": "featureName",
                "value": "SEO_QUICKLOOK"
              }
            ],
            "storageKey": "isEnabledByLocale(featureName:\"SEO_QUICKLOOK\")"
          },
          {
            "kind": "ScalarField",
            "alias": "isFavoritesEnabled",
            "name": "isEnabledByLocale",
            "args": [
              {
                "kind": "Literal",
                "name": "featureName",
                "value": "FAVORITES"
              }
            ],
            "storageKey": "isEnabledByLocale(featureName:\"FAVORITES\")"
          },
          {
            "kind": "ScalarField",
            "alias": "isMoreWaysToBrowseEnabled",
            "name": "isEnabledByLocale",
            "args": [
              {
                "kind": "Literal",
                "name": "featureName",
                "value": "MORE_WAYS_TO_BROWSE"
              }
            ],
            "storageKey": "isEnabledByLocale(featureName:\"MORE_WAYS_TO_BROWSE\")"
          },
          {
            "kind": "ScalarField",
            "alias": "isMessageCenterEnabled",
            "name": "isEnabledByLocale",
            "args": [
              {
                "kind": "Literal",
                "name": "featureName",
                "value": "MESSAGE_CENTER"
              }
            ],
            "storageKey": "isEnabledByLocale(featureName:\"MESSAGE_CENTER\")"
          },
          {
            "kind": "ScalarField",
            "alias": "isReviewsEnabled",
            "name": "isEnabledByLocale",
            "args": [
              {
                "kind": "Literal",
                "name": "featureName",
                "value": "ORDER_FEEDBACK"
              }
            ],
            "storageKey": "isEnabledByLocale(featureName:\"ORDER_FEEDBACK\")"
          },
          {
            "kind": "ScalarField",
            "alias": "disableEmailOnlyMc",
            "name": "isEnabledByLocale",
            "args": [
              {
                "kind": "Literal",
                "name": "featureName",
                "value": "DISABLE_EMAIL_ONLY_MC"
              }
            ],
            "storageKey": "isEnabledByLocale(featureName:\"DISABLE_EMAIL_ONLY_MC\")"
          },
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "gdprDisplayInfo",
            "storageKey": null,
            "args": null,
            "concreteType": "gdprDisplayInfo",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "isGdprApplicable",
                "args": [
                  (v14/*: any*/)
                ],
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "marketingOptInMessage",
                "args": null,
                "storageKey": null
              }
            ]
          },
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "itemRead",
            "storageKey": null,
            "args": [
              {
                "kind": "Variable",
                "name": "itemIds",
                "variableName": "itemIds"
              }
            ],
            "concreteType": null,
            "plural": true,
            "selections": [
              (v15/*: any*/),
              (v9/*: any*/),
              {
                "kind": "InlineFragment",
                "type": "Item",
                "selections": [
                  (v16/*: any*/),
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "defaultSkuId",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "saveSearchData",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "SaveSearchDataType",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "page",
                        "args": null,
                        "storageKey": null
                      },
                      (v17/*: any*/)
                    ]
                  },
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "skus",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "ItemSkuType",
                    "plural": true,
                    "selections": [
                      (v18/*: any*/),
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "images",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "ItemPhoto",
                        "plural": true,
                        "selections": [
                          (v9/*: any*/)
                        ]
                      },
                      (v9/*: any*/),
                      (v19/*: any*/),
                      (v20/*: any*/),
                      (v21/*: any*/),
                      (v22/*: any*/),
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "quantitySelectOptions",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "SkuQuantityOption",
                        "plural": true,
                        "selections": [
                          (v23/*: any*/),
                          (v24/*: any*/)
                        ]
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "setSize",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": "skuLeadTime",
                        "name": "leadTime",
                        "args": (v25/*: any*/),
                        "storageKey": "leadTime(pageType:\"PDP\")"
                      },
                      {
                        "kind": "Condition",
                        "passingValue": true,
                        "condition": "isMultiSku",
                        "selections": [
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "pricing",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "ItemPricing",
                            "plural": false,
                            "selections": [
                              (v26/*: any*/),
                              (v27/*: any*/),
                              (v28/*: any*/),
                              (v29/*: any*/),
                              (v30/*: any*/)
                            ]
                          },
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "displayInfo",
                            "storageKey": null,
                            "args": (v31/*: any*/),
                            "concreteType": "SkuDisplayInfo",
                            "plural": false,
                            "selections": [
                              {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "pricing",
                                "storageKey": null,
                                "args": null,
                                "concreteType": "PriceInfoDisplay",
                                "plural": false,
                                "selections": [
                                  (v32/*: any*/),
                                  (v33/*: any*/),
                                  (v34/*: any*/),
                                  (v35/*: any*/),
                                  (v36/*: any*/),
                                  (v37/*: any*/),
                                  (v38/*: any*/),
                                  (v39/*: any*/),
                                  (v40/*: any*/),
                                  (v41/*: any*/),
                                  (v42/*: any*/)
                                ]
                              }
                            ]
                          }
                        ]
                      }
                    ]
                  },
                  (v19/*: any*/),
                  (v20/*: any*/),
                  (v43/*: any*/),
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "itemType",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "isSold",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": "image",
                    "name": "firstPhotoWebPath",
                    "args": (v44/*: any*/),
                    "storageKey": "firstPhotoWebPath(size:\"thumb\")"
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "isListingNotListed",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "isListingUnlisted",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "seller",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "Seller",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "isInternal",
                        "args": null,
                        "storageKey": null
                      },
                      (v9/*: any*/),
                      (v19/*: any*/),
                      (v12/*: any*/),
                      (v4/*: any*/)
                    ]
                  },
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "breadcrumbs",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "ItemBreadcrumb",
                    "plural": true,
                    "selections": [
                      (v45/*: any*/),
                      (v46/*: any*/),
                      (v47/*: any*/)
                    ]
                  },
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "photos",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "ItemPhoto",
                    "plural": true,
                    "selections": [
                      (v48/*: any*/),
                      (v9/*: any*/)
                    ]
                  },
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "sortedPhotos",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "ItemPhoto",
                    "plural": true,
                    "selections": [
                      (v48/*: any*/),
                      (v49/*: any*/),
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "imageSkuXrefs",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "ImageSkuXref",
                        "plural": true,
                        "selections": [
                          (v18/*: any*/),
                          (v9/*: any*/)
                        ]
                      },
                      (v9/*: any*/)
                    ]
                  },
                  (v50/*: any*/),
                  (v51/*: any*/),
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "classification",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "ItemClassification",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "categories",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "ItemCategory",
                        "plural": true,
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "precedence",
                            "args": null,
                            "storageKey": null
                          },
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "category",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "Category",
                            "plural": false,
                            "selections": [
                              (v17/*: any*/),
                              (v52/*: any*/),
                              (v9/*: any*/)
                            ]
                          }
                        ]
                      },
                      (v53/*: any*/)
                    ]
                  },
                  (v54/*: any*/),
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "creators",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "ItemCreator",
                    "plural": true,
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "creator",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "Creator",
                        "plural": false,
                        "selections": [
                          (v17/*: any*/),
                          (v47/*: any*/),
                          (v9/*: any*/)
                        ]
                      },
                      (v9/*: any*/)
                    ]
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "isPrivateVisibilityType",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "hasPrivateListing",
                    "args": null,
                    "storageKey": null
                  },
                  (v55/*: any*/),
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "pricing",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "ItemPricing",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "totalAmount",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "FinancialAmount",
                        "plural": false,
                        "selections": [
                          (v6/*: any*/),
                          (v56/*: any*/)
                        ]
                      },
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "prices",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "Price",
                        "plural": true,
                        "selections": [
                          (v57/*: any*/),
                          (v4/*: any*/),
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "amount",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "FinancialAmount",
                            "plural": false,
                            "selections": [
                              (v56/*: any*/)
                            ]
                          }
                        ]
                      },
                      (v26/*: any*/),
                      (v27/*: any*/),
                      (v28/*: any*/),
                      (v29/*: any*/),
                      (v30/*: any*/)
                    ]
                  },
                  (v58/*: any*/),
                  (v52/*: any*/),
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "isDepositAvailable",
                    "args": (v59/*: any*/),
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "isNewAndMadeToOrder",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "attributes",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "ItemAttributes",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "leadTime",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "AttributeValue",
                        "plural": true,
                        "selections": [
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "option",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "AttributeOption",
                            "plural": false,
                            "selections": [
                              (v17/*: any*/),
                              (v60/*: any*/),
                              (v9/*: any*/)
                            ]
                          },
                          (v24/*: any*/)
                        ]
                      },
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "customizable",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "AttributeValue",
                        "plural": true,
                        "selections": [
                          (v61/*: any*/)
                        ]
                      }
                    ]
                  },
                  {
                    "kind": "LinkedField",
                    "alias": "blurbReturnPolicy",
                    "name": "returnPolicy",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "ReturnPolicy",
                    "plural": false,
                    "selections": [
                      (v62/*: any*/),
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "notifyDays",
                        "args": null,
                        "storageKey": null
                      },
                      (v9/*: any*/)
                    ]
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "hasShipmentQuotes",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": "itemIsOnHold",
                    "name": "isOnHold",
                    "args": (v59/*: any*/),
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "hasPreQuotedShipping",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "locationBrowseUrl",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "LinkData",
                    "plural": false,
                    "selections": (v63/*: any*/)
                  },
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "address",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "Address",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "alias": "itemAddress",
                        "name": "displayCityStateCountry",
                        "args": [
                          {
                            "kind": "Literal",
                            "name": "fullCountryName",
                            "value": true
                          }
                        ],
                        "storageKey": "displayCityStateCountry(fullCountryName:true)"
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "isGalleryRoomAddress",
                        "args": null,
                        "storageKey": null
                      },
                      (v9/*: any*/)
                    ]
                  },
                  (v64/*: any*/),
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "urgency",
                    "storageKey": null,
                    "args": (v66/*: any*/),
                    "concreteType": "Urgency",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "pdpBlurbDisplayInfo",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "PdpBlurbDisplayInfo",
                        "plural": false,
                        "selections": [
                          (v45/*: any*/),
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "displayTitle",
                            "args": null,
                            "storageKey": null
                          },
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "displaySubtitle",
                            "args": null,
                            "storageKey": null
                          }
                        ]
                      }
                    ]
                  },
                  (v67/*: any*/),
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "englishDescription",
                    "args": null,
                    "storageKey": null
                  },
                  (v68/*: any*/),
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "pdpTypeDisplay",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "returnPolicy",
                    "storageKey": null,
                    "args": (v66/*: any*/),
                    "concreteType": "ReturnPolicy",
                    "plural": false,
                    "selections": [
                      (v62/*: any*/),
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "buyerCopy",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "ReturnPolicyCopy",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "returnCopy",
                            "args": null,
                            "storageKey": null
                          }
                        ]
                      },
                      (v9/*: any*/)
                    ]
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "isAvailable",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "dibsReference",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "isDeleted",
                    "args": null,
                    "storageKey": null
                  },
                  (v69/*: any*/),
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "isComplete",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "isListingListed",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "activeHold",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "Hold",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "displayTimeToExpire",
                        "args": null,
                        "storageKey": null
                      },
                      (v9/*: any*/)
                    ]
                  },
                  {
                    "kind": "LinkedField",
                    "alias": "level1Category",
                    "name": "getCategoriesByLevel",
                    "storageKey": "getCategoriesByLevel(level:1)",
                    "args": [
                      {
                        "kind": "Literal",
                        "name": "level",
                        "value": 1
                      }
                    ],
                    "concreteType": "Category",
                    "plural": true,
                    "selections": (v70/*: any*/)
                  },
                  {
                    "kind": "Condition",
                    "passingValue": true,
                    "condition": "isClient",
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "pdpTrackingVpvParams",
                        "args": (v66/*: any*/),
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": "makeOfferVpvParams",
                        "name": "pdpTrackingVpvParams",
                        "args": [
                          {
                            "kind": "Literal",
                            "name": "excludedPurchaseStatuses",
                            "value": [
                              "RET",
                              "CUST"
                            ]
                          },
                          (v65/*: any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "hasRequestedHoldForBuyer",
                        "args": (v59/*: any*/),
                        "storageKey": null
                      },
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "displayInfo",
                        "storageKey": null,
                        "args": (v31/*: any*/),
                        "concreteType": "ItemDisplayInfo",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "ctas",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "CTADisplay",
                            "plural": false,
                            "selections": [
                              (v71/*: any*/),
                              (v72/*: any*/),
                              (v73/*: any*/),
                              (v74/*: any*/),
                              (v75/*: any*/),
                              (v76/*: any*/),
                              (v77/*: any*/)
                            ]
                          },
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "pricing",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "PriceInfoDisplay",
                            "plural": false,
                            "selections": [
                              (v33/*: any*/),
                              (v34/*: any*/),
                              (v37/*: any*/),
                              (v36/*: any*/),
                              (v32/*: any*/),
                              (v35/*: any*/),
                              (v38/*: any*/),
                              (v39/*: any*/),
                              (v40/*: any*/),
                              (v41/*: any*/),
                              (v42/*: any*/)
                            ]
                          }
                        ]
                      }
                    ]
                  },
                  {
                    "kind": "Condition",
                    "passingValue": true,
                    "condition": "fetchPdp",
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "microdata",
                        "args": [
                          {
                            "kind": "Variable",
                            "name": "currency",
                            "variableName": "forcedCurrency"
                          }
                        ],
                        "storageKey": null
                      },
                      (v78/*: any*/),
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "pdpMeta",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "pdpMetaItems",
                        "plural": false,
                        "selections": [
                          (v43/*: any*/),
                          (v67/*: any*/),
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "ogTitle",
                            "args": null,
                            "storageKey": null
                          },
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "productPriceAmount",
                            "args": null,
                            "storageKey": null
                          },
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "productPriceCurrency",
                            "args": null,
                            "storageKey": null
                          }
                        ]
                      },
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "photos",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "ItemPhoto",
                        "plural": true,
                        "selections": [
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "versions",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "ItemPhotoVersion",
                            "plural": true,
                            "selections": [
                              (v79/*: any*/),
                              {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "type",
                                "storageKey": null,
                                "args": null,
                                "concreteType": "ImageVersionType",
                                "plural": false,
                                "selections": (v80/*: any*/)
                              }
                            ]
                          },
                          (v81/*: any*/),
                          (v82/*: any*/)
                        ]
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "isMissingTranslatedItemTitle",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "isPriceUponRequest",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "seller",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "Seller",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "alias": "monthsSinceStartDate",
                            "name": "timeSinceStartDate",
                            "args": [
                              {
                                "kind": "Literal",
                                "name": "unit",
                                "value": "MONTH"
                              }
                            ],
                            "storageKey": "timeSinceStartDate(unit:\"MONTH\")"
                          },
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "isDistinguished",
                            "args": null,
                            "storageKey": null
                          },
                          {
                            "kind": "ScalarField",
                            "alias": "isRewardsTier2",
                            "name": "isAnchorListMember",
                            "args": [
                              {
                                "kind": "Literal",
                                "name": "listName",
                                "value": "SELLER_REWARDS_2"
                              }
                            ],
                            "storageKey": "isAnchorListMember(listName:\"SELLER_REWARDS_2\")"
                          },
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "sellerTiers",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "SellerTiers",
                            "plural": false,
                            "selections": [
                              {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "isGoldTier",
                                "args": null,
                                "storageKey": null
                              },
                              {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "isPlatinumTier",
                                "args": null,
                                "storageKey": null
                              },
                              {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "sellerTierDataNotFound",
                                "args": null,
                                "storageKey": null
                              }
                            ]
                          },
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "orderFeedbackPdp",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "SellerOrderFeedbackPdpQueryConnection",
                            "plural": false,
                            "selections": [
                              {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "metadata",
                                "storageKey": null,
                                "args": null,
                                "concreteType": "SellerOrderFeedbackPdpQueryMetadata",
                                "plural": false,
                                "selections": [
                                  {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "aggregatedFeedback",
                                    "storageKey": null,
                                    "args": null,
                                    "concreteType": "AggregatedOrderFeedbackType",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "kind": "LinkedField",
                                        "alias": null,
                                        "name": "overallExperience",
                                        "storageKey": null,
                                        "args": null,
                                        "concreteType": "AggregatedOrderFeedbackQuestionType",
                                        "plural": false,
                                        "selections": [
                                          {
                                            "kind": "ScalarField",
                                            "alias": null,
                                            "name": "mean",
                                            "args": null,
                                            "storageKey": null
                                          }
                                        ]
                                      }
                                    ]
                                  }
                                ]
                              },
                              {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "totalResults",
                                "args": null,
                                "storageKey": null
                              },
                              {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "edges",
                                "storageKey": null,
                                "args": null,
                                "concreteType": "SellerOrderFeedbackPdpQueryEdge",
                                "plural": true,
                                "selections": [
                                  {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "node",
                                    "storageKey": null,
                                    "args": null,
                                    "concreteType": "OrderFeedbackPdp",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "kind": "ScalarField",
                                        "alias": null,
                                        "name": "completedDate",
                                        "args": null,
                                        "storageKey": null
                                      },
                                      {
                                        "kind": "LinkedField",
                                        "alias": null,
                                        "name": "transaction",
                                        "storageKey": null,
                                        "args": null,
                                        "concreteType": "Transaction",
                                        "plural": false,
                                        "selections": [
                                          (v20/*: any*/),
                                          {
                                            "kind": "LinkedField",
                                            "alias": null,
                                            "name": "buyer",
                                            "storageKey": null,
                                            "args": null,
                                            "concreteType": "User",
                                            "plural": false,
                                            "selections": [
                                              {
                                                "kind": "LinkedField",
                                                "alias": null,
                                                "name": "profile",
                                                "storageKey": null,
                                                "args": null,
                                                "concreteType": "Profile",
                                                "plural": false,
                                                "selections": [
                                                  (v83/*: any*/)
                                                ]
                                              },
                                              (v9/*: any*/)
                                            ]
                                          },
                                          {
                                            "kind": "LinkedField",
                                            "alias": null,
                                            "name": "shipment",
                                            "storageKey": null,
                                            "args": null,
                                            "concreteType": "Shipment",
                                            "plural": false,
                                            "selections": [
                                              {
                                                "kind": "LinkedField",
                                                "alias": null,
                                                "name": "shippingAddress",
                                                "storageKey": null,
                                                "args": null,
                                                "concreteType": "Address",
                                                "plural": false,
                                                "selections": [
                                                  {
                                                    "kind": "ScalarField",
                                                    "alias": null,
                                                    "name": "displayState",
                                                    "args": null,
                                                    "storageKey": null
                                                  },
                                                  {
                                                    "kind": "ScalarField",
                                                    "alias": null,
                                                    "name": "country",
                                                    "args": null,
                                                    "storageKey": null
                                                  },
                                                  {
                                                    "kind": "ScalarField",
                                                    "alias": null,
                                                    "name": "displayCountry",
                                                    "args": null,
                                                    "storageKey": null
                                                  },
                                                  (v9/*: any*/)
                                                ]
                                              },
                                              (v9/*: any*/)
                                            ]
                                          },
                                          (v9/*: any*/)
                                        ]
                                      },
                                      {
                                        "kind": "LinkedField",
                                        "alias": null,
                                        "name": "overallExperience",
                                        "storageKey": null,
                                        "args": null,
                                        "concreteType": null,
                                        "plural": false,
                                        "selections": [
                                          (v15/*: any*/),
                                          {
                                            "kind": "ScalarField",
                                            "alias": null,
                                            "name": "rating",
                                            "args": null,
                                            "storageKey": null
                                          }
                                        ]
                                      },
                                      {
                                        "kind": "LinkedField",
                                        "alias": null,
                                        "name": "publicNote",
                                        "storageKey": null,
                                        "args": null,
                                        "concreteType": null,
                                        "plural": false,
                                        "selections": [
                                          (v15/*: any*/),
                                          {
                                            "kind": "ScalarField",
                                            "alias": null,
                                            "name": "freetext",
                                            "args": null,
                                            "storageKey": null
                                          },
                                          {
                                            "kind": "ScalarField",
                                            "alias": null,
                                            "name": "visible",
                                            "args": null,
                                            "storageKey": null
                                          }
                                        ]
                                      },
                                      {
                                        "kind": "LinkedField",
                                        "alias": null,
                                        "name": "item",
                                        "storageKey": null,
                                        "args": null,
                                        "concreteType": "Item",
                                        "plural": false,
                                        "selections": [
                                          (v19/*: any*/),
                                          (v43/*: any*/),
                                          (v55/*: any*/),
                                          (v50/*: any*/),
                                          (v85/*: any*/),
                                          {
                                            "kind": "LinkedField",
                                            "alias": null,
                                            "name": "linkData",
                                            "storageKey": null,
                                            "args": null,
                                            "concreteType": "LinkData",
                                            "plural": false,
                                            "selections": (v63/*: any*/)
                                          },
                                          (v9/*: any*/)
                                        ]
                                      },
                                      (v19/*: any*/),
                                      (v9/*: any*/)
                                    ]
                                  }
                                ]
                              }
                            ]
                          },
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "sellerProfile",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "SellerProfile",
                            "plural": false,
                            "selections": [
                              {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "company",
                                "args": null,
                                "storageKey": null
                              }
                            ]
                          },
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "tradeAssociations",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "TradeAssociation",
                            "plural": true,
                            "selections": [
                              (v19/*: any*/),
                              (v9/*: any*/),
                              (v47/*: any*/)
                            ]
                          },
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "trackedPhone",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "Phone",
                            "plural": false,
                            "selections": [
                              {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "phoneNumber",
                                "args": null,
                                "storageKey": null
                              },
                              (v9/*: any*/)
                            ]
                          },
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "agreementStart",
                            "args": null,
                            "storageKey": null
                          },
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "analytics",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "MCAnalytics",
                            "plural": false,
                            "selections": [
                              {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "metrics",
                                "storageKey": null,
                                "args": null,
                                "concreteType": "MCAnalyticsMetrics",
                                "plural": false,
                                "selections": [
                                  {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "responseTime",
                                    "storageKey": null,
                                    "args": null,
                                    "concreteType": "MCMetricResponseTime",
                                    "plural": false,
                                    "selections": [
                                      (v24/*: any*/)
                                    ]
                                  }
                                ]
                              }
                            ]
                          },
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "liveStorefrontProfile",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "StorefrontProfile",
                            "plural": false,
                            "selections": [
                              {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "aboutUsUnbranded",
                                "args": null,
                                "storageKey": null
                              },
                              {
                                "kind": "LinkedField",
                                "alias": "headshots",
                                "name": "photos",
                                "storageKey": "photos(photoType:\"DEALER_STOREFRONT_HEADSHOT\")",
                                "args": [
                                  {
                                    "kind": "Literal",
                                    "name": "photoType",
                                    "value": "DEALER_STOREFRONT_HEADSHOT"
                                  }
                                ],
                                "concreteType": "Photo",
                                "plural": true,
                                "selections": [
                                  (v4/*: any*/),
                                  (v46/*: any*/),
                                  (v9/*: any*/)
                                ]
                              },
                              {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "galleryAlbum",
                                "storageKey": null,
                                "args": null,
                                "concreteType": "MediaAlbum",
                                "plural": false,
                                "selections": [
                                  {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "mediaList",
                                    "storageKey": null,
                                    "args": null,
                                    "concreteType": "MediaElement",
                                    "plural": true,
                                    "selections": [
                                      (v49/*: any*/),
                                      {
                                        "kind": "LinkedField",
                                        "alias": null,
                                        "name": "element",
                                        "storageKey": null,
                                        "args": null,
                                        "concreteType": null,
                                        "plural": false,
                                        "selections": [
                                          (v15/*: any*/),
                                          (v9/*: any*/),
                                          {
                                            "kind": "InlineFragment",
                                            "type": "Photo",
                                            "selections": [
                                              (v46/*: any*/)
                                            ]
                                          }
                                        ]
                                      },
                                      (v9/*: any*/)
                                    ]
                                  },
                                  (v9/*: any*/)
                                ]
                              },
                              (v9/*: any*/),
                              {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "aboutUs",
                                "args": null,
                                "storageKey": null
                              },
                              {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "photos",
                                "storageKey": null,
                                "args": null,
                                "concreteType": "Photo",
                                "plural": true,
                                "selections": [
                                  (v46/*: any*/),
                                  {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "type",
                                    "storageKey": null,
                                    "args": null,
                                    "concreteType": "PhotoType",
                                    "plural": false,
                                    "selections": (v86/*: any*/)
                                  },
                                  (v9/*: any*/)
                                ]
                              }
                            ]
                          },
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "isMakerOrManufacturer",
                            "args": null,
                            "storageKey": null
                          },
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "sellerPreferences",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "SellerPreferences",
                            "plural": false,
                            "selections": [
                              (v60/*: any*/)
                            ]
                          },
                          {
                            "kind": "Condition",
                            "passingValue": true,
                            "condition": "fetchUser",
                            "selections": [
                              {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "favoritesByUser",
                                "storageKey": null,
                                "args": [
                                  {
                                    "kind": "Variable",
                                    "name": "userIds",
                                    "variableName": "userId"
                                  }
                                ],
                                "concreteType": "Favorite",
                                "plural": true,
                                "selections": (v84/*: any*/)
                              }
                            ]
                          }
                        ]
                      },
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "metrics",
                        "storageKey": "metrics(metricTypes:[\"LISTING_VIEWS\"],timeRange:\"LAST_6_MONTHS\")",
                        "args": [
                          {
                            "kind": "Literal",
                            "name": "metricTypes",
                            "value": [
                              "LISTING_VIEWS"
                            ]
                          },
                          {
                            "kind": "Literal",
                            "name": "timeRange",
                            "value": "LAST_6_MONTHS"
                          }
                        ],
                        "concreteType": "MetricDetailType",
                        "plural": true,
                        "selections": [
                          (v24/*: any*/),
                          (v9/*: any*/)
                        ]
                      },
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "attributes",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "ItemAttributes",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "period",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "AttributeValue",
                            "plural": true,
                            "selections": [
                              {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "option",
                                "storageKey": null,
                                "args": null,
                                "concreteType": "AttributeOption",
                                "plural": false,
                                "selections": (v86/*: any*/)
                              }
                            ]
                          }
                        ]
                      },
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "viewInRoomPhotos",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "viewInRoomPhotos",
                        "plural": true,
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "src",
                            "args": null,
                            "storageKey": null
                          },
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "credits",
                            "args": null,
                            "storageKey": null
                          },
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "srcSetProps",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "viewInRoomPhotosSrcSet",
                            "plural": false,
                            "selections": [
                              {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "sizes",
                                "args": null,
                                "storageKey": null
                              },
                              {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "srcSet",
                                "args": null,
                                "storageKey": null
                              }
                            ]
                          },
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "centerPosition",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "viewInRoomPhotosCenterPosition",
                            "plural": false,
                            "selections": [
                              {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "top",
                                "args": null,
                                "storageKey": null
                              },
                              {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "left",
                                "args": null,
                                "storageKey": null
                              }
                            ]
                          },
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "comparatorWidth",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "viewInRoomPhotosComparatorWidth",
                            "plural": false,
                            "selections": [
                              {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "pixel",
                                "args": null,
                                "storageKey": null
                              },
                              {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "inches",
                                "args": null,
                                "storageKey": null
                              }
                            ]
                          }
                        ]
                      },
                      {
                        "kind": "LinkedField",
                        "alias": "dealerDetailsDisplayInfo",
                        "name": "displayInfo",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "ItemDisplayInfo",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "ctas",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "CTADisplay",
                            "plural": false,
                            "selections": [
                              (v73/*: any*/)
                            ]
                          }
                        ]
                      },
                      (v87/*: any*/),
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "measurement",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "ItemMeasurement",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "convertedMeasurements",
                            "storageKey": "convertedMeasurements(unit:\"IN\")",
                            "args": [
                              {
                                "kind": "Literal",
                                "name": "unit",
                                "value": "IN"
                              }
                            ],
                            "concreteType": "ItemConvertedMeasurementsType",
                            "plural": false,
                            "selections": [
                              {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "width",
                                "args": null,
                                "storageKey": null
                              },
                              {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "height",
                                "args": null,
                                "storageKey": null
                              }
                            ]
                          },
                          {
                            "kind": "LinkedField",
                            "alias": "hoverDimensionsWidth",
                            "name": "display",
                            "storageKey": "display(addLabel:false,fields:[\"width\"])",
                            "args": [
                              (v88/*: any*/),
                              {
                                "kind": "Literal",
                                "name": "fields",
                                "value": [
                                  "width"
                                ]
                              }
                            ],
                            "concreteType": "ItemDisplayMeasurementType",
                            "plural": true,
                            "selections": (v89/*: any*/)
                          },
                          {
                            "kind": "LinkedField",
                            "alias": "hoverDimensionsHeight",
                            "name": "display",
                            "storageKey": "display(addLabel:false,fields:[\"height\"])",
                            "args": [
                              (v88/*: any*/),
                              {
                                "kind": "Literal",
                                "name": "fields",
                                "value": [
                                  "height"
                                ]
                              }
                            ],
                            "concreteType": "ItemDisplayMeasurementType",
                            "plural": true,
                            "selections": (v89/*: any*/)
                          }
                        ]
                      },
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "videoVimeo",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "VideoVimeo",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "thumbnail",
                            "args": [
                              {
                                "kind": "Literal",
                                "name": "includePlayButton",
                                "value": false
                              },
                              {
                                "kind": "Literal",
                                "name": "pad",
                                "value": false
                              },
                              {
                                "kind": "Literal",
                                "name": "size",
                                "value": "w100h75"
                              }
                            ],
                            "storageKey": "thumbnail(includePlayButton:false,pad:false,size:\"w100h75\")"
                          },
                          (v4/*: any*/),
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "vimeoId",
                            "args": null,
                            "storageKey": null
                          }
                        ]
                      },
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "sortedPhotos",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "ItemPhoto",
                        "plural": true,
                        "selections": [
                          (v19/*: any*/),
                          (v81/*: any*/),
                          (v82/*: any*/)
                        ]
                      },
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "pdpDetailsDisplay",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "PdpDetail",
                        "plural": true,
                        "selections": [
                          (v90/*: any*/),
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "delimiter",
                            "args": null,
                            "storageKey": null
                          },
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "detailDisplayName",
                            "args": null,
                            "storageKey": null
                          },
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "detailValues",
                            "storageKey": null,
                            "args": null,
                            "concreteType": null,
                            "plural": true,
                            "selections": [
                              (v15/*: any*/),
                              (v90/*: any*/),
                              (v52/*: any*/),
                              (v47/*: any*/),
                              {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "linkOrder",
                                "args": null,
                                "storageKey": null
                              },
                              (v18/*: any*/),
                              {
                                "kind": "InlineFragment",
                                "type": "PdpDetailVersionsValue",
                                "selections": [
                                  {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "price",
                                    "storageKey": null,
                                    "args": null,
                                    "concreteType": "FinancialAmount",
                                    "plural": false,
                                    "selections": (v8/*: any*/)
                                  }
                                ]
                              }
                            ]
                          }
                        ]
                      },
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "creatorContent",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "BrowseContentModule",
                        "plural": false,
                        "selections": [
                          (v17/*: any*/),
                          (v67/*: any*/),
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "role",
                            "args": null,
                            "storageKey": null
                          },
                          (v9/*: any*/)
                        ]
                      },
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "internalBuyLinks",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "InternalBuyLinkType",
                        "plural": true,
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "anchorText",
                            "args": null,
                            "storageKey": null
                          },
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "url",
                            "args": null,
                            "storageKey": null
                          },
                          (v9/*: any*/)
                        ]
                      },
                      {
                        "kind": "LinkedField",
                        "alias": "sellerItems",
                        "name": "moreLikeThis",
                        "storageKey": "moreLikeThis(first:4,seller:\"INCLUDE\")",
                        "args": [
                          {
                            "kind": "Literal",
                            "name": "first",
                            "value": 4
                          },
                          {
                            "kind": "Literal",
                            "name": "seller",
                            "value": "INCLUDE"
                          }
                        ],
                        "concreteType": "moreLikeThisConnection",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "edges",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "moreLikeThisEdge",
                            "plural": true,
                            "selections": [
                              {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "node",
                                "storageKey": null,
                                "args": null,
                                "concreteType": "Item",
                                "plural": false,
                                "selections": [
                                  (v19/*: any*/),
                                  (v69/*: any*/),
                                  (v58/*: any*/),
                                  (v52/*: any*/),
                                  (v43/*: any*/),
                                  (v91/*: any*/),
                                  (v92/*: any*/),
                                  (v68/*: any*/),
                                  (v16/*: any*/),
                                  (v78/*: any*/),
                                  (v51/*: any*/),
                                  (v96/*: any*/),
                                  (v64/*: any*/),
                                  (v97/*: any*/),
                                  (v98/*: any*/),
                                  (v102/*: any*/),
                                  (v104/*: any*/),
                                  (v9/*: any*/)
                                ]
                              }
                            ]
                          }
                        ]
                      },
                      {
                        "kind": "LinkedField",
                        "alias": "similarLandingItems",
                        "name": "moreLikeThis",
                        "storageKey": "moreLikeThis(first:12)",
                        "args": (v106/*: any*/),
                        "concreteType": "moreLikeThisConnection",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "edges",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "moreLikeThisEdge",
                            "plural": true,
                            "selections": [
                              {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "node",
                                "storageKey": null,
                                "args": null,
                                "concreteType": "Item",
                                "plural": false,
                                "selections": [
                                  (v19/*: any*/),
                                  (v69/*: any*/),
                                  (v58/*: any*/),
                                  (v52/*: any*/),
                                  (v43/*: any*/),
                                  (v91/*: any*/),
                                  (v50/*: any*/),
                                  (v54/*: any*/),
                                  {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "creators",
                                    "storageKey": null,
                                    "args": null,
                                    "concreteType": "ItemCreator",
                                    "plural": true,
                                    "selections": [
                                      {
                                        "kind": "LinkedField",
                                        "alias": null,
                                        "name": "creator",
                                        "storageKey": null,
                                        "args": null,
                                        "concreteType": "Creator",
                                        "plural": false,
                                        "selections": (v86/*: any*/)
                                      },
                                      (v9/*: any*/)
                                    ]
                                  },
                                  {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "photos",
                                    "storageKey": "photos(limit:1)",
                                    "args": (v99/*: any*/),
                                    "concreteType": "ItemPhoto",
                                    "plural": true,
                                    "selections": [
                                      (v81/*: any*/),
                                      (v101/*: any*/),
                                      (v9/*: any*/),
                                      (v100/*: any*/)
                                    ]
                                  },
                                  (v9/*: any*/)
                                ]
                              }
                            ]
                          }
                        ]
                      },
                      {
                        "kind": "LinkedField",
                        "alias": "similarGridItems",
                        "name": "moreLikeThis",
                        "storageKey": "moreLikeThis(first:8,seller:\"EXCLUDE\")",
                        "args": [
                          {
                            "kind": "Literal",
                            "name": "first",
                            "value": 8
                          },
                          {
                            "kind": "Literal",
                            "name": "seller",
                            "value": "EXCLUDE"
                          }
                        ],
                        "concreteType": "moreLikeThisConnection",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "edges",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "moreLikeThisEdge",
                            "plural": true,
                            "selections": [
                              {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "node",
                                "storageKey": null,
                                "args": null,
                                "concreteType": "Item",
                                "plural": false,
                                "selections": [
                                  (v19/*: any*/),
                                  (v69/*: any*/),
                                  (v52/*: any*/),
                                  (v58/*: any*/),
                                  (v43/*: any*/),
                                  (v91/*: any*/),
                                  (v92/*: any*/),
                                  (v68/*: any*/),
                                  (v16/*: any*/),
                                  (v78/*: any*/),
                                  (v51/*: any*/),
                                  (v96/*: any*/),
                                  (v64/*: any*/),
                                  (v97/*: any*/),
                                  (v98/*: any*/),
                                  (v102/*: any*/),
                                  (v104/*: any*/),
                                  (v9/*: any*/)
                                ]
                              }
                            ]
                          }
                        ]
                      },
                      {
                        "kind": "Condition",
                        "passingValue": true,
                        "condition": "fetchUser",
                        "selections": [
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "displayInfo",
                            "storageKey": null,
                            "args": (v31/*: any*/),
                            "concreteType": "ItemDisplayInfo",
                            "plural": false,
                            "selections": [
                              {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "ctas",
                                "storageKey": null,
                                "args": null,
                                "concreteType": "CTADisplay",
                                "plural": false,
                                "selections": [
                                  (v71/*: any*/)
                                ]
                              }
                            ]
                          }
                        ]
                      }
                    ]
                  },
                  {
                    "kind": "Condition",
                    "passingValue": true,
                    "condition": "isTrade",
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "complementaryItems",
                        "storageKey": "complementaryItems(first:12)",
                        "args": (v106/*: any*/),
                        "concreteType": "complementaryItemsConnection",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "edges",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "complementaryItemsEdge",
                            "plural": true,
                            "selections": [
                              {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "node",
                                "storageKey": null,
                                "args": null,
                                "concreteType": "Item",
                                "plural": false,
                                "selections": [
                                  (v43/*: any*/),
                                  (v19/*: any*/),
                                  (v69/*: any*/),
                                  (v58/*: any*/),
                                  (v52/*: any*/),
                                  (v92/*: any*/),
                                  (v68/*: any*/),
                                  (v16/*: any*/),
                                  (v78/*: any*/),
                                  (v51/*: any*/),
                                  (v96/*: any*/),
                                  (v64/*: any*/),
                                  (v97/*: any*/),
                                  (v98/*: any*/),
                                  (v102/*: any*/),
                                  (v104/*: any*/),
                                  (v9/*: any*/),
                                  {
                                    "kind": "Condition",
                                    "passingValue": true,
                                    "condition": "isClient",
                                    "selections": [
                                      {
                                        "kind": "ScalarField",
                                        "alias": null,
                                        "name": "ecommerceTrackingParams",
                                        "args": (v66/*: any*/),
                                        "storageKey": null
                                      }
                                    ]
                                  }
                                ]
                              }
                            ]
                          }
                        ]
                      },
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "displayPrice",
                        "storageKey": null,
                        "args": [
                          (v1/*: any*/),
                          (v93/*: any*/),
                          (v94/*: any*/)
                        ],
                        "concreteType": "ItemDisplayPriceType",
                        "plural": true,
                        "selections": [
                          (v95/*: any*/)
                        ]
                      },
                      (v87/*: any*/),
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "isFashion",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "isOnHoldForBuyer",
                        "args": [
                          {
                            "kind": "Variable",
                            "name": "currentBuyerId",
                            "variableName": "userId"
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "lastTransaction",
                        "storageKey": null,
                        "args": (v59/*: any*/),
                        "concreteType": "Transaction",
                        "plural": false,
                        "selections": [
                          (v107/*: any*/),
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "offers",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "Offer",
                            "plural": true,
                            "selections": [
                              (v108/*: any*/),
                              (v109/*: any*/),
                              (v9/*: any*/)
                            ]
                          },
                          (v9/*: any*/)
                        ]
                      }
                    ]
                  },
                  {
                    "kind": "Condition",
                    "passingValue": true,
                    "condition": "fetchUser",
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "isInProcurement",
                        "args": (v66/*: any*/),
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "hasActiveHoldForBuyer",
                        "args": (v59/*: any*/),
                        "storageKey": null
                      },
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "lastActiveTransaction",
                        "storageKey": null,
                        "args": (v59/*: any*/),
                        "concreteType": "Transaction",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "summary",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "TransactionSummaryObject",
                            "plural": false,
                            "selections": [
                              {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "retailPrice",
                                "storageKey": null,
                                "args": null,
                                "concreteType": "Price",
                                "plural": false,
                                "selections": (v110/*: any*/)
                              },
                              {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "salePrice",
                                "storageKey": null,
                                "args": null,
                                "concreteType": "Price",
                                "plural": false,
                                "selections": (v110/*: any*/)
                              },
                              {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "netPrice",
                                "storageKey": null,
                                "args": null,
                                "concreteType": "Price",
                                "plural": false,
                                "selections": (v110/*: any*/)
                              }
                            ]
                          },
                          (v107/*: any*/),
                          (v111/*: any*/),
                          (v9/*: any*/)
                        ]
                      }
                    ]
                  },
                  {
                    "kind": "Condition",
                    "passingValue": true,
                    "condition": "isMultiSku",
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "skus",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "ItemSkuType",
                        "plural": true,
                        "selections": [
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "displayInfo",
                            "storageKey": null,
                            "args": (v31/*: any*/),
                            "concreteType": "SkuDisplayInfo",
                            "plural": false,
                            "selections": [
                              {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "ctas",
                                "storageKey": null,
                                "args": null,
                                "concreteType": "CTADisplay",
                                "plural": false,
                                "selections": [
                                  (v72/*: any*/),
                                  (v73/*: any*/),
                                  (v74/*: any*/),
                                  (v75/*: any*/),
                                  (v76/*: any*/),
                                  (v77/*: any*/)
                                ]
                              }
                            ]
                          }
                        ]
                      },
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "variableAttributes",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "VariableAttribute",
                        "plural": true,
                        "selections": [
                          (v19/*: any*/),
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "variableAttributeData",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "VariableAttributeSortType",
                            "plural": false,
                            "selections": [
                              (v47/*: any*/),
                              {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "primaryAttribute",
                                "storageKey": null,
                                "args": null,
                                "concreteType": "Attribute",
                                "plural": false,
                                "selections": (v86/*: any*/)
                              },
                              {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "swatchSort",
                                "storageKey": null,
                                "args": null,
                                "concreteType": "SwatchSort",
                                "plural": true,
                                "selections": [
                                  (v49/*: any*/),
                                  {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "swatch",
                                    "storageKey": null,
                                    "args": null,
                                    "concreteType": "Swatch",
                                    "plural": false,
                                    "selections": [
                                      (v19/*: any*/),
                                      (v47/*: any*/),
                                      (v67/*: any*/),
                                      {
                                        "kind": "ScalarField",
                                        "alias": null,
                                        "name": "imageUrl",
                                        "args": null,
                                        "storageKey": null
                                      },
                                      {
                                        "kind": "LinkedField",
                                        "alias": null,
                                        "name": "material",
                                        "storageKey": null,
                                        "args": null,
                                        "concreteType": "SwatchAttributeByName",
                                        "plural": false,
                                        "selections": (v80/*: any*/)
                                      },
                                      {
                                        "kind": "LinkedField",
                                        "alias": null,
                                        "name": "color",
                                        "storageKey": null,
                                        "args": null,
                                        "concreteType": "SwatchAttributeByName",
                                        "plural": false,
                                        "selections": [
                                          (v17/*: any*/),
                                          {
                                            "kind": "ScalarField",
                                            "alias": null,
                                            "name": "parentName",
                                            "args": null,
                                            "storageKey": null
                                          }
                                        ]
                                      },
                                      (v9/*: any*/)
                                    ]
                                  }
                                ]
                              }
                            ]
                          },
                          (v9/*: any*/)
                        ]
                      },
                      {
                        "kind": "LinkedField",
                        "alias": "buyerSideSkus",
                        "name": "skus",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "ItemSkuType",
                        "plural": true,
                        "selections": [
                          (v19/*: any*/),
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "firstPhotoWebPath",
                            "args": (v44/*: any*/),
                            "storageKey": "firstPhotoWebPath(size:\"thumb\")"
                          },
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "pricing",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "ItemPricing",
                            "plural": false,
                            "selections": [
                              {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "hidePrice",
                                "args": null,
                                "storageKey": null
                              },
                              {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "retailPrice",
                                "storageKey": null,
                                "args": null,
                                "concreteType": "FinancialAmount",
                                "plural": false,
                                "selections": (v112/*: any*/)
                              },
                              {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "netPrice",
                                "storageKey": null,
                                "args": null,
                                "concreteType": "FinancialAmount",
                                "plural": false,
                                "selections": (v112/*: any*/)
                              },
                              {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "salePrice",
                                "storageKey": null,
                                "args": null,
                                "concreteType": "FinancialAmount",
                                "plural": false,
                                "selections": (v112/*: any*/)
                              }
                            ]
                          },
                          (v21/*: any*/),
                          (v22/*: any*/),
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "leadTime",
                            "args": (v25/*: any*/),
                            "storageKey": "leadTime(pageType:\"PDP\")"
                          },
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "variableAttributeSelections",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "variableAttributeSelectionsType",
                            "plural": true,
                            "selections": [
                              {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "variableAttribute",
                                "storageKey": null,
                                "args": null,
                                "concreteType": "VariableAttribute",
                                "plural": false,
                                "selections": (v84/*: any*/)
                              },
                              {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "swatch",
                                "storageKey": null,
                                "args": null,
                                "concreteType": "Swatch",
                                "plural": false,
                                "selections": (v84/*: any*/)
                              },
                              (v9/*: any*/)
                            ]
                          },
                          (v9/*: any*/)
                        ]
                      }
                    ]
                  },
                  {
                    "kind": "Condition",
                    "passingValue": false,
                    "condition": "isTrade",
                    "selections": [
                      (v87/*: any*/),
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "getCategoriesByLevel",
                        "storageKey": "getCategoriesByLevel(level:2)",
                        "args": [
                          {
                            "kind": "Literal",
                            "name": "level",
                            "value": 2
                          }
                        ],
                        "concreteType": "Category",
                        "plural": true,
                        "selections": (v70/*: any*/)
                      }
                    ]
                  }
                ]
              }
            ]
          },
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "transactions",
            "storageKey": null,
            "args": (v113/*: any*/),
            "concreteType": "TransactionConnection",
            "plural": false,
            "selections": [
              {
                "kind": "Condition",
                "passingValue": true,
                "condition": "isMultiSku",
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "edges",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "TransactionEdge",
                    "plural": true,
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "node",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "Transaction",
                        "plural": false,
                        "selections": [
                          (v18/*: any*/),
                          (v107/*: any*/),
                          (v111/*: any*/),
                          (v9/*: any*/)
                        ]
                      }
                    ]
                  }
                ]
              }
            ]
          },
          (v9/*: any*/),
          {
            "kind": "Condition",
            "passingValue": true,
            "condition": "fetchUser",
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "buyerItemConversation",
                "storageKey": null,
                "args": (v3/*: any*/),
                "concreteType": "Conversation",
                "plural": false,
                "selections": (v84/*: any*/)
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "user",
                "storageKey": null,
                "args": (v66/*: any*/),
                "concreteType": "User",
                "plural": false,
                "selections": [
                  (v19/*: any*/),
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "canShowSellerName",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "isVerifiedTrade",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "profile",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "Profile",
                    "plural": false,
                    "selections": [
                      (v5/*: any*/),
                      (v114/*: any*/),
                      (v47/*: any*/),
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "measurementUnit",
                        "args": null,
                        "storageKey": null
                      },
                      (v83/*: any*/)
                    ]
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "isVip",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": "canRequestShippingQuotePermission",
                    "name": "hasPermission",
                    "args": [
                      {
                        "kind": "Literal",
                        "name": "name",
                        "value": "B_REQUEST_SHIPPING_QUOTE"
                      }
                    ],
                    "storageKey": "hasPermission(name:\"B_REQUEST_SHIPPING_QUOTE\")"
                  },
                  {
                    "kind": "ScalarField",
                    "alias": "canSeeNetPrice",
                    "name": "hasPermission",
                    "args": [
                      {
                        "kind": "Literal",
                        "name": "name",
                        "value": "B_NET_PRICE"
                      }
                    ],
                    "storageKey": "hasPermission(name:\"B_NET_PRICE\")"
                  },
                  {
                    "kind": "ScalarField",
                    "alias": "canCheckoutWithCheck",
                    "name": "hasPermission",
                    "args": [
                      {
                        "kind": "Literal",
                        "name": "name",
                        "value": "B_CHECKOUT_CHECK"
                      }
                    ],
                    "storageKey": "hasPermission(name:\"B_CHECKOUT_CHECK\")"
                  },
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "activePromotion",
                    "storageKey": null,
                    "args": [
                      (v2/*: any*/)
                    ],
                    "concreteType": "Promotion",
                    "plural": false,
                    "selections": (v115/*: any*/)
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "verifiedTradeStatus",
                    "args": null,
                    "storageKey": null
                  },
                  (v9/*: any*/),
                  {
                    "kind": "Condition",
                    "passingValue": true,
                    "condition": "fetchFollowSearch",
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "favorites",
                        "storageKey": null,
                        "args": [
                          {
                            "kind": "Literal",
                            "name": "first",
                            "value": 1
                          },
                          {
                            "kind": "Variable",
                            "name": "pages",
                            "variableName": "followSearchPages"
                          },
                          {
                            "kind": "Literal",
                            "name": "types",
                            "value": [
                              "SEARCH"
                            ]
                          }
                        ],
                        "concreteType": "favoritesConnection",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "edges",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "favoritesEdge",
                            "plural": true,
                            "selections": [
                              {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "node",
                                "storageKey": null,
                                "args": null,
                                "concreteType": "Favorite",
                                "plural": false,
                                "selections": (v84/*: any*/)
                              }
                            ]
                          }
                        ]
                      }
                    ]
                  },
                  {
                    "kind": "Condition",
                    "passingValue": true,
                    "condition": "isVip",
                    "selections": [
                      {
                        "kind": "Condition",
                        "passingValue": false,
                        "condition": "isTrade",
                        "selections": [
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "userRelationships",
                            "storageKey": "userRelationships(relationshipType:\"VIP\")",
                            "args": [
                              (v116/*: any*/)
                            ],
                            "concreteType": "UserRelationship",
                            "plural": true,
                            "selections": [
                              {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "userDataB",
                                "storageKey": null,
                                "args": null,
                                "concreteType": null,
                                "plural": true,
                                "selections": [
                                  (v15/*: any*/),
                                  {
                                    "kind": "InlineFragment",
                                    "type": "VipRepData",
                                    "selections": (v117/*: any*/)
                                  }
                                ]
                              },
                              (v9/*: any*/)
                            ]
                          }
                        ]
                      }
                    ]
                  },
                  {
                    "kind": "Condition",
                    "passingValue": true,
                    "condition": "isTrade",
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "tradeFirmDesignManagerProfile",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "TradeFirmDesignManagerProfileType",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "hasAccount",
                            "args": null,
                            "storageKey": null
                          },
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "accountType",
                            "args": null,
                            "storageKey": null
                          }
                        ]
                      },
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "socialNetworks",
                        "storageKey": "socialNetworks(socialNetworkNames:\"DESIGN_MANAGER\")",
                        "args": [
                          {
                            "kind": "Literal",
                            "name": "socialNetworkNames",
                            "value": "DESIGN_MANAGER"
                          }
                        ],
                        "concreteType": null,
                        "plural": true,
                        "selections": [
                          (v15/*: any*/),
                          (v9/*: any*/),
                          {
                            "kind": "InlineFragment",
                            "type": "DesignManagerSocialNetworkType",
                            "selections": [
                              (v4/*: any*/)
                            ]
                          }
                        ]
                      },
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "expiringPromotion",
                        "storageKey": "expiringPromotion(daysToExpiration:7,promoCodes:[\"TRADEWELCOME\",\"TRADE1STWELCOME\"])",
                        "args": [
                          {
                            "kind": "Literal",
                            "name": "daysToExpiration",
                            "value": 7
                          },
                          {
                            "kind": "Literal",
                            "name": "promoCodes",
                            "value": [
                              "TRADEWELCOME",
                              "TRADE1STWELCOME"
                            ]
                          }
                        ],
                        "concreteType": "Promotion",
                        "plural": false,
                        "selections": [
                          (v118/*: any*/),
                          (v10/*: any*/),
                          (v9/*: any*/)
                        ]
                      },
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "tradeFirmRewards",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "TradeFirmRewards",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "currentPromoSegment",
                            "storageKey": null,
                            "args": (v66/*: any*/),
                            "concreteType": "currentPromoSegmentType",
                            "plural": false,
                            "selections": [
                              {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "promotion",
                                "storageKey": null,
                                "args": null,
                                "concreteType": "Promotion",
                                "plural": false,
                                "selections": [
                                  (v10/*: any*/),
                                  {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "buyerExpirationDate",
                                    "args": null,
                                    "storageKey": null
                                  },
                                  (v9/*: any*/)
                                ]
                              }
                            ]
                          },
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "expiringPromoSegment",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "expiringPromoSegmentType",
                            "plural": false,
                            "selections": [
                              {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "expiringSegmentCode",
                                "args": null,
                                "storageKey": null
                              },
                              (v118/*: any*/)
                            ]
                          }
                        ]
                      },
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "tradeFirm",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "TradeFirmType",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "rewards",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "TradeFirmRewards",
                            "plural": false,
                            "selections": [
                              {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "currentPromoSegment",
                                "storageKey": null,
                                "args": (v66/*: any*/),
                                "concreteType": "currentPromoSegmentType",
                                "plural": false,
                                "selections": [
                                  {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "segmentCode",
                                    "args": null,
                                    "storageKey": null
                                  }
                                ]
                              },
                              {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "currentProgram",
                                "storageKey": null,
                                "args": null,
                                "concreteType": "ParentProgram",
                                "plural": false,
                                "selections": [
                                  {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "programInfo",
                                    "storageKey": null,
                                    "args": null,
                                    "concreteType": "LoyaltyProgram",
                                    "plural": false,
                                    "selections": (v115/*: any*/)
                                  },
                                  {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "childPrograms",
                                    "storageKey": "childPrograms(filter:\"ENHANCED_BUYER_PROTECTION\")",
                                    "args": [
                                      {
                                        "kind": "Literal",
                                        "name": "filter",
                                        "value": "ENHANCED_BUYER_PROTECTION"
                                      }
                                    ],
                                    "concreteType": "LoyaltyProgram",
                                    "plural": true,
                                    "selections": (v115/*: any*/)
                                  }
                                ]
                              }
                            ]
                          },
                          (v9/*: any*/)
                        ]
                      }
                    ]
                  },
                  {
                    "kind": "Condition",
                    "passingValue": true,
                    "condition": "fetchUserRecentHistoryItem",
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "recentHistoryItems",
                        "storageKey": null,
                        "args": (v119/*: any*/),
                        "concreteType": "RecentHistoryItemsConnection",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "edges",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "RecentHistoryItemsEdge",
                            "plural": true,
                            "selections": [
                              {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "node",
                                "storageKey": null,
                                "args": null,
                                "concreteType": "Item",
                                "plural": false,
                                "selections": [
                                  (v55/*: any*/),
                                  (v20/*: any*/),
                                  (v50/*: any*/),
                                  (v43/*: any*/),
                                  (v52/*: any*/),
                                  (v58/*: any*/),
                                  (v19/*: any*/),
                                  (v69/*: any*/),
                                  (v85/*: any*/),
                                  (v9/*: any*/),
                                  (v15/*: any*/)
                                ]
                              },
                              {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "cursor",
                                "args": null,
                                "storageKey": null
                              }
                            ]
                          },
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "pageInfo",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "PageInfo",
                            "plural": false,
                            "selections": [
                              {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "endCursor",
                                "args": null,
                                "storageKey": null
                              },
                              {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "hasNextPage",
                                "args": null,
                                "storageKey": null
                              }
                            ]
                          }
                        ]
                      },
                      {
                        "kind": "LinkedHandle",
                        "alias": null,
                        "name": "recentHistoryItems",
                        "args": (v119/*: any*/),
                        "handle": "connection",
                        "key": "getRecentHistory_recentHistoryItems",
                        "filters": [
                          "excludeItemPks"
                        ]
                      }
                    ]
                  }
                ]
              },
              {
                "kind": "LinkedField",
                "alias": "vipUserRelationships",
                "name": "userRelationships",
                "storageKey": null,
                "args": [
                  (v116/*: any*/),
                  {
                    "kind": "Variable",
                    "name": "userIds",
                    "variableName": "relationshipUserIds"
                  }
                ],
                "concreteType": "UserRelationship",
                "plural": true,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "userDataB",
                    "storageKey": null,
                    "args": null,
                    "concreteType": null,
                    "plural": true,
                    "selections": [
                      (v15/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "type": "VipRepData",
                        "selections": [
                          (v114/*: any*/),
                          (v83/*: any*/),
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "phoneNumber",
                            "args": (v13/*: any*/),
                            "storageKey": "phoneNumber(formatType:\"INTERNATIONAL\")"
                          }
                        ]
                      }
                    ]
                  },
                  (v9/*: any*/)
                ]
              }
            ]
          },
          {
            "kind": "Condition",
            "passingValue": true,
            "condition": "fetchRegionalInfo",
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "regionalInfo",
                "storageKey": null,
                "args": [
                  (v14/*: any*/),
                  {
                    "kind": "Variable",
                    "name": "zipCode",
                    "variableName": "userZipCode"
                  }
                ],
                "concreteType": "RegionalInfo",
                "plural": true,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "regionsByZipCode",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "RegionsByZipCode",
                    "plural": true,
                    "selections": (v117/*: any*/)
                  },
                  (v9/*: any*/)
                ]
              }
            ]
          },
          {
            "kind": "Condition",
            "passingValue": false,
            "condition": "isTrade",
            "selections": [
              {
                "kind": "ScalarField",
                "alias": "isConsultAnExpertDisabled",
                "name": "isEnabledByLocale",
                "args": [
                  {
                    "kind": "Literal",
                    "name": "featureName",
                    "value": "DISABLE_CONSULT_AN_EXPERT"
                  }
                ],
                "storageKey": "isEnabledByLocale(featureName:\"DISABLE_CONSULT_AN_EXPERT\")"
              }
            ]
          },
          {
            "kind": "Condition",
            "passingValue": true,
            "condition": "fetchPdp",
            "selections": [
              {
                "kind": "ScalarField",
                "alias": "isPdpStfEnabled",
                "name": "isEnabled",
                "args": [
                  {
                    "kind": "Literal",
                    "name": "key",
                    "value": "enablePdpStf"
                  }
                ],
                "storageKey": "isEnabled(key:\"enablePdpStf\")"
              },
              (v120/*: any*/),
              {
                "kind": "ScalarField",
                "alias": "isFacebookShareEnabled",
                "name": "isEnabledByLocale",
                "args": [
                  {
                    "kind": "Literal",
                    "name": "featureName",
                    "value": "FACEBOOK_SHARE"
                  }
                ],
                "storageKey": "isEnabledByLocale(featureName:\"FACEBOOK_SHARE\")"
              },
              {
                "kind": "ScalarField",
                "alias": "videoPdpEnabled",
                "name": "isEnabled",
                "args": [
                  {
                    "kind": "Literal",
                    "name": "key",
                    "value": "videoPdpEnabled"
                  }
                ],
                "storageKey": "isEnabled(key:\"videoPdpEnabled\")"
              },
              {
                "kind": "ScalarField",
                "alias": "isRequestMoreImagesEnabled",
                "name": "isEnabledByLocale",
                "args": [
                  {
                    "kind": "Literal",
                    "name": "featureName",
                    "value": "REQUEST_MORE_IMAGES"
                  }
                ],
                "storageKey": "isEnabledByLocale(featureName:\"REQUEST_MORE_IMAGES\")"
              },
              {
                "kind": "ScalarField",
                "alias": "isContactSupportEnabled",
                "name": "isEnabledByLocale",
                "args": [
                  {
                    "kind": "Literal",
                    "name": "featureName",
                    "value": "CONTACT_1STDIBS"
                  }
                ],
                "storageKey": "isEnabledByLocale(featureName:\"CONTACT_1STDIBS\")"
              },
              {
                "kind": "ScalarField",
                "alias": "isAboutTheMakerEnabled",
                "name": "isEnabledByLocale",
                "args": [
                  {
                    "kind": "Literal",
                    "name": "featureName",
                    "value": "ABOUT_THE_MAKER"
                  }
                ],
                "storageKey": "isEnabledByLocale(featureName:\"ABOUT_THE_MAKER\")"
              },
              {
                "kind": "ScalarField",
                "alias": "disablePdpExitModal",
                "name": "isEnabled",
                "args": [
                  {
                    "kind": "Literal",
                    "name": "key",
                    "value": "disablePdpExitModal"
                  }
                ],
                "storageKey": "isEnabled(key:\"disablePdpExitModal\")"
              },
              {
                "kind": "ScalarField",
                "alias": "disableConsumerSourcingModal",
                "name": "isEnabled",
                "args": [
                  {
                    "kind": "Literal",
                    "name": "key",
                    "value": "disableConsumerSourcingModal"
                  }
                ],
                "storageKey": "isEnabled(key:\"disableConsumerSourcingModal\")"
              },
              {
                "kind": "ScalarField",
                "alias": "isPdpUrlTranslationEnabled",
                "name": "isEnabled",
                "args": [
                  {
                    "kind": "Literal",
                    "name": "key",
                    "value": "translatedPdpUrls"
                  }
                ],
                "storageKey": "isEnabled(key:\"translatedPdpUrls\")"
              }
            ]
          },
          {
            "kind": "Condition",
            "passingValue": true,
            "condition": "isTrade",
            "selections": [
              (v120/*: any*/)
            ]
          },
          {
            "kind": "Condition",
            "passingValue": true,
            "condition": "isClient",
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "transactions",
                "storageKey": null,
                "args": (v113/*: any*/),
                "concreteType": "TransactionConnection",
                "plural": false,
                "selections": [
                  {
                    "kind": "Condition",
                    "passingValue": true,
                    "condition": "isMultiSku",
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "edges",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "TransactionEdge",
                        "plural": true,
                        "selections": [
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "node",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "Transaction",
                            "plural": false,
                            "selections": [
                              {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "isCanceled",
                                "args": null,
                                "storageKey": null
                              }
                            ]
                          }
                        ]
                      }
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "operationKind": "query",
    "name": "PdpRespLayoutRefetchQuery",
    "id": "app-buyer-finding/257.0.0-2020-03-26T15:41:46.002Z/PdpRespLayoutRefetchQuery",
    "text": null,
    "metadata": {}
  }
};
})();
(node as any).hash = '37a45badc7aaad31a996051d6a90218a';
export default node;
